module.exports = __webpack_public_path__ + "media/images/img_top_catch-d89bd08a79e99a6901192f292daf6446.png";